import { Component, Inject, ElementRef, OnInit, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AppAttendanceService } from '../../../core/services/appAttendanceService.service';
import { AppAttendance } from '../../../core/models/appAttendace.model';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { formatDate } from '../../helpers/getIsoStringDate.js'
import { convertToUTC } from '../../helpers/getUTCDate.js'
import { adjustTimeToSystemTimezone } from '../../helpers/getLocalDate.js'
import { MarcajeCoordinatesDialog } from '../marcaje-coordinates-dialog/marcaje-coordinates-dialog.component';
import { DOCUMENT } from '@angular/common';
@Component({
  selector: 'app-edit-marcajes-dialog',
  templateUrl: './edit-marcajes-dialog.component.html',
  styleUrls: ['./edit-marcajes-dialog.component.scss'],
  providers: [AppAttendanceService]
})
export class EditMarcajesDialog {

  panelIcon = 'calendar-plus'; // font awesome icon
  panelTitle = 'Añadir registro';
  panelDescription = '';
  appAttendanceModel: AppAttendance;
  @ViewChild('scrollableSection', { static: false }) scrollableSection: ElementRef;
  isNew: boolean = false;
  now: Date = new Date();
  minDate: Date = new Date(new Date().setDate(this.now.getDate() - 4));
  maxDate: Date = new Date(new Date().setDate(this.now.getDate() + 1));
  defaultData: any;
  notes: string;
  date: string;
  time: string;
  dateAndHour: string;
  selectedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  constructor(
    public dialogRef: MatDialogRef<EditMarcajesDialog>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    protected _editMarcajesDialog: MatDialog,
    public appAttendanceService: AppAttendanceService,
    protected _messageDialog: MessageDialog,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2

  ) {
    if (inputData && inputData.defaultData) {
      this.defaultData = inputData.defaultData;
      this.appAttendanceModel = new AppAttendance({ source: 'WEB', valid: 'true', company: this.defaultData.company, companyData: this.defaultData.companyData, userData: this.defaultData.userData, user: this.defaultData.userData.id, coordinates: null, timeZone: this.selectedTimeZone });
      this.isNew = true;
    } else if (inputData) {
      inputData.attendanceAt = formatDate(adjustTimeToSystemTimezone(inputData.attendanceAt).iso, true, true);
      this.panelTitle = `Editar registro (${inputData.userData.fullName}) (${formatDate(inputData.localAttendanceAt ?? inputData.attendanceAt, false, true, true)})`;
      this.dateAndHour = formatDate(inputData.localAttendanceAt ?? inputData.attendanceAt, true, true, true);
      this.appAttendanceModel = inputData;
      this.notes = inputData.notes
      this.isNew = false;
    } else {
      this.appAttendanceModel = new AppAttendance({ source: 'WEB', valid: 'Sí' });
      this.isNew = true;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const labels = document.querySelectorAll('.date-picker div label.azul-a3Factura');
      labels.forEach(label => {
        (label as HTMLElement).style.fontSize = '13px';
        (label as HTMLElement).style.transform = 'translateY(10px)';
      });
    }, 0);
  }


  closePopUp(response: any) {
    this.dialogRef.close(response);
  }

  onEditorPreparing(e): void {
    if (e.parentType === 'searchPanel') {
      e.editorOptions.stylingMode = 'underlined';
    }
  }

  companySelectedChanged(e): void {
    this.appAttendanceModel.company = e[0].id;
    this.appAttendanceModel.companyData = {
      company1: e[0].id,
      name: e[0].name,
      companyCode: e[0].companyCode,
      identifierNumber: e[0].nif,
    }

    //Inicializar lo que depende de con company
    this.appAttendanceModel.user = null
    this.appAttendanceModel.userData = null
    this.appAttendanceModel.type = null
  }

  employeeChanged(e): void {
    this.appAttendanceModel.user = e.user1;
  }

  attendanceTypeChanged(e): void {
    this.appAttendanceModel.type = e
  }

  workCenterChanged(e): void {
    this.appAttendanceModel.workCenter = e
  }

  toFixedIso(date) {
    const pad = (n, z = 2) => String(n).padStart(z, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${pad(date.getMilliseconds(), 3)}Z`;
  }

  onDateChange(e) {

    if (this.defaultData || !this.inputData?.attendanceRecord1) {

      this.appAttendanceModel.localAttendanceAt = this.toFixedIso(new Date(e.value));
    }

  }

  onTimeZoneChange(e) {
    if (this.defaultData || !this.inputData?.attendanceRecord1) {
      this.appAttendanceModel.timeZone = e;
    }
  }

  onSubmit(): void {
    this.appAttendanceModel.notes = this.notes;
    if (this.appAttendanceModel.attendanceRecord1) {
      this.appAttendanceService.updateModel({ id: this.appAttendanceModel.attendanceRecord1, data: this.appAttendanceModel }).subscribe(
        (response) => {
          this.closePopUp(null);
        },
        (error) => {
          console.error('Error al crear el registro:', error);
        }
      );
    } else {
      this.appAttendanceService.createModel(this.appAttendanceModel).subscribe(
        (response) => {
          this.closePopUp(response);
        },
        (error) => {
          console.error('Error al crear el registro:', error);
        }
      );
    }
  }




  autoGrow(event: Event): void {
    const textArea = event.target as HTMLTextAreaElement;
    textArea.style.height = 'auto';
    textArea.style.height = Math.min(textArea.scrollHeight, 72) + 'px';
  }


  isDisabled(): boolean {
    if (!this.inputData?.attendanceRecord1 || this.defaultData) {
      return !this.appAttendanceModel.company || !this.appAttendanceModel.workCenter || !this.appAttendanceModel.localAttendanceAt || !this.appAttendanceModel.timeZone ||
        !this.appAttendanceModel.type || !this.appAttendanceModel.user;
    } else {
      return !this.notes;
    }
  }

  onLocationCheck() {

    const dialogRef = this._editMarcajesDialog.open(MarcajeCoordinatesDialog, {
      width: '100%',
      data: this.appAttendanceModel,
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
    });
  }



}